import { usePaneRouterContextSafe } from "@/components/PaneRouter";
import { Button } from "@/components/ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { useIsPaneOpen, usePaneGoBack } from "@/hooks/pane-routing";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router";

export function PaneBackButton() {
  const navigate = useNavigate();
  const paneGoBack = usePaneGoBack();
  const paneContext = usePaneRouterContextSafe();
  const isRightPaneOpen = useIsPaneOpen("rightPane");

  if (!isRightPaneOpen && !paneContext) return null;

  const handleBack = () => {
    if (paneContext) {
      paneGoBack();
      return;
    }
    navigate(-1);
  };

  return (
    <TooltipProvider>
      <Tooltip delayDuration={0}>
        <TooltipTrigger asChild>
          <Button
            variant="toolbarGhost"
            size="icon-sm"
            onClick={handleBack}
            className="shrink-0"
            aria-label="Go back"
          >
            <ArrowLeft />
          </Button>
        </TooltipTrigger>
        <TooltipContent side="bottom">Go back</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
